module.exports = __webpack_public_path__ + "9704bb5eebb2a1967c14bff088a21731.pdf";